import { createRef, forwardRef, Ref, useImperativeHandle, useMemo, useState } from "react"
import { onChange } from "../../../../../../../../../utils/types"
import { ReScheduleActivityProps, ReScheduleActivityRef } from "./types"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import { FooterSimple } from "../../../../../../../../../components/buttons/footer"
import { DateModalRange, DateModalRangeRef } from "../../../../../../../../../components/dinamicForm/dateModal"
import dayjs, { Dayjs } from "dayjs"

export const ReScheduleActivity = forwardRef(({ cancel, confirm, timeZone, defaultDate = { from: dayjs(), to: null } }: ReScheduleActivityProps, ref: Ref<ReScheduleActivityRef>) => {
    const { t } = useTranslation()
    const refRange = createRef<DateModalRangeRef>()
    const [loading, setLoading] = useState(false)
    const [value, setValue] = useState<{ from: Dayjs | null; to: Dayjs | null }>(defaultDate)
    const errorMessage = useMemo(() => {
        return {
            to: dayjs(value.to).isAfter(dayjs(value.from).add(4, 'minutes')) || !value.to ? '' : t('general.validations.minimus5minute'),
            from: ''
        }
    }, [value.from, value.to])

    const onChange: onChange = ({ target }) => {
        const { name, value } = target
        setValue((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    useImperativeHandle(ref, () => ({
        getData: value,
        loading: (value) => { setLoading(() => value) }
    }))
    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2, marginTop: 1 }}>
            <DateModalRange
                setDate={(payload) => {
                    onChange({
                        target: {
                            name: payload.target.name,
                            value: payload.target.value?.valueOf(),
                        }
                    })
                }}
                from={dayjs(value.from)}
                to={value.to ? dayjs(value.to) : null}
                mimTimeZone={timeZone}
                ref={refRange}
                defaultErrors={errorMessage}
            />

            <FooterSimple
                cancel={{
                    children: t('general.cancel'),
                    onClick: cancel
                }}
                confirm={{
                    children: t('general.reSchedule'),
                    loading: loading,
                    disabled: !value.from || !value.to || !!errorMessage.to,
                    onClick: confirm,
                    variant: 'primary_c'
                }}
            />
        </Box>
    )
})